
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/sadhguru/[mmm]/[mmmArticle]",
      function () {
        return require("private-next-pages/[region]/sadhguru/[mmm]/[mmmArticle]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/sadhguru/[mmm]/[mmmArticle]"])
      });
    }
  